export const getActiveServiceWorker = (): Promise<ServiceWorker> =>
  new Promise((resolve, reject) => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          const sw = registration.active;

          if (sw) {
            resolve(sw);
          } else {
            reject(new Error("[SW] Service worker is not active"));
          }
        })
        .catch(() => {
          reject(new Error("[SW] Service worker is not registered"));
        });
    } else {
      reject(new Error("[SW] Service worker is not supported"));
    }
  });
